import {
    ComponentChildren,
    ComponentChild,
    toChildArray,
    cloneElement
} from "preact";
import DropdownItem, { DropdownItemProps } from "../DropdownItem";
import DropdownParentItem from "../DropdownItem/DropdownParentItem";

export default function cloneDropdownItems<V>(
    componentChildren: ComponentChildren,
    dropdownItemProps: Partial<DropdownItemProps<V>>
): ComponentChild[] {
    return toChildArray(componentChildren).map(child => {
        const isChildNode = typeof child === "object";

        const isChildDropdownParentItem = isChildNode &&
            typeof child.type !== "string" &&
            child.type.name === DropdownParentItem.name;

        const isChildDropdownItem = isChildNode &&
            typeof child.type !== "string" &&
            child.type.name === DropdownItem.name;

        if (isChildDropdownParentItem) {
            return cloneElement(child, dropdownItemProps);
        } else if (isChildDropdownItem) {
            const { subItem, onHover } = dropdownItemProps;
            return cloneElement(child, {
                ...dropdownItemProps,
                onHover: subItem ? undefined : onHover
            });
        } else if (isChildNode && child.props && child.props.children) {
            return cloneElement(child, {
                children: cloneDropdownItems(child.props.children, dropdownItemProps)
            });
        }
        return child;
    });
}
